module.exports = __webpack_public_path__ + "img/Screenshot_20240125_144202_Gmail_bg.e1bd1fa8.jpg";